<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >

            <v-card class="elevation-12" v-if="!lostpassword">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer />
             
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="E-Mail"
                    name="login"
                    type="text"
                    v-model="email"
                    :rules="[rules.required]"
                    outlined
                  />

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    v-model="password"
                    :rules="[rules.required]"
                    outlined
                    v-on:keyup.enter="submit();"
                  />
                </v-form>
              </v-card-text>

              <v-divider class="pb-4"></v-divider>

              <v-card-text class="pa-0 pl-2">

                <v-btn :loading="loading.login" depressed class="mx-2" color="primary" @click="submit();">Login</v-btn>
                <v-btn depressed class="mx-2" text @click="ToggleLostPassword">Lost Password</v-btn>
                
                <v-spacer />

              </v-card-text>

              <v-divider class="mt-4" v-if="error"></v-divider>

              <v-alert class="mx-4 mt-4" outlined type="error" v-if="error">
                {{error}}
              </v-alert>

              <v-alert class="mx-4 mt-4" outlined type="success" v-if="success">
                {{success}}
              </v-alert>
              
              <v-divider class="mt-4"></v-divider>

              <v-btn
                text
                @click="providerLogin('google');"
                class="ma-4 mr-0"
                outlined color="grey"
              > 
                
                Google login

              </v-btn>

              <v-btn
                text
                @click="providerLogin('microsoft');"
                class="ma-4"
                outlined color="grey"
              > 
                
                Microsoft login

              </v-btn>

            </v-card>

            <v-card class="elevation-12" v-if="lostpassword">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Recover Password</v-toolbar-title>
                <v-spacer />
             
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="E-Mail"
                    name="login"
                    type="text"
                    v-model="email"
                    :rules="[rules.required]"
                    outlined
                  />

                </v-form>

              </v-card-text>

              <v-card-actions class="pa-0 pb-4 pl-2">

                <v-btn :loading="loading.login" depressed class="mx-2" color="primary" @click="SendLostPassword();">{{ $t("Recover password") }}</v-btn>
                <v-btn outlined class="mx-2" color="grey" @click="ToggleLostPassword();">{{ $t("Cancel") }}</v-btn>
                
                <v-spacer />

              </v-card-actions>

              <v-divider class="mt-0" v-if="error || success"></v-divider>

              <div class="pa-4" v-if="error || success">
                  
                <v-alert class="ma-0" outlined type="error" v-if="error">
                  {{error}}
                </v-alert>

                <v-alert class="ma-0" outlined type="success" v-if="success">
                  {{success}}
                </v-alert>

              </div>

            </v-card>

          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    
  }
</script>

<script>

import Header from '../components/Header';
import firebase from "firebase";
import { mapGetters } from "vuex";

export default {
    name: 'Login',
    props: {
        source: String,
    },
    components: {
    Header,
    },
    computed: {
      // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
        user: "user/current"
      })
    },
    watch: {
      user() {
        
        if(this.user.loggedin){
          
          this.$router.push({ name: "Companies" });

        }else{
          // console.log('Nais hoor testtttt logout');
        }

      },
    },
    data () {
      return {
        email: '',
        password: '',
        error: null,
        success: null,
        lostpassword: false,
        loading: {
            login: false
        },
        rules: {
          required: value => !!value || 'Required.',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
      }
    },
    created() {

      if(this.user && this.user.loggedin){
        
        this.$router.push({
          name: "Companies"
        });

      }

    },
    methods: {
        submit() {

          this.loading.login = true ;

          firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
            .then(data => {
              this.loading.login = false ;
              this.$router.push({ name: "Companies" });
              
            })
            .catch(err => {
              this.loading.login = false ;
              this.error = err.message;
              _this.$store.commit("app/SET_ERROR", error) ;
            });

        },
        ToggleLostPassword(){

          if(this.lostpassword){
            this.lostpassword = false ;
          }else{
            this.lostpassword = true ;
          }

        },
        SendLostPassword(){

          let _this = this ; 
          this.loading.login = false ;

          if(!this.email){
            this.error = "Please enter an e-mail address" ;
          };

          firebase.auth().sendPasswordResetEmail(this.email).then(function() {
            _this.error = null ;
            _this.success = "Please check your e-mail to recover your password." ;
            _this.loading.login = false ;
          }).catch(err => {
            _this.error = err.message;
            _this.loading.login = false ;
          });

        },
        providerLogin(providerName) {

          if(providerName == 'google'){
            var provider = new firebase.auth.GoogleAuthProvider();
          }else if(providerName == 'microsoft'){

            var provider = new firebase.auth.OAuthProvider('microsoft.com');

            provider.setCustomParameters({
              // Force re-consent.
              prompt: 'consent',
              // Target specific email with login hint.
              login_hint: 'user@firstadd.onmicrosoft.com'
            });

            provider.setCustomParameters({
              // Optional "tenant" parameter in case you are using an Azure AD tenant.
              // eg. '8eaef023-2b34-4da1-9baa-8bc8c9d6a490' or 'contoso.onmicrosoft.com'
              // or "common" for tenant-independent tokens.
              // The default value is "common".
              tenant: 'a19b3694-dcd1-40ce-a49b-bbce797220db'
            });

          }

          firebase.auth().signInWithPopup(provider).then(function(result) {
            // This gives you a Google Access Token. You can use it to access the Google API.
            var token = result.credential.accessToken;
            // The signed-in user info.
            var user = result.user;
            // ...

            this.$router.push({ name: "Companies" });
            
          }).catch(function(error) {

            let snackbar = {
                color: 'red',
                show: true,
                text: error.message+" ("+error.code+")"
            }

            this.$store.commit('SET_SNACKBAR', snackbar) ;
            
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...

          });
            
        }
    }
};

</script>
